import { data } from "jquery";
import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Colors, Web_url } from "../../../common/Const";
import { images } from "../../../common/Images";
import String from "../../../lang/String";
import store from "../../../redux/Store";
import SkeletonEffect from "./SkeletonEffect";

function Budget(props) {
  const { budgetData } = props;
  // console.log("Budget -->", budgetData);
  const navigate = useNavigate()
  const BudgetFilter = (budgetId) => {
    store.dispatch({ type: "setBudparams", payload: budgetId });
    navigate('/filter');
    // navigate('/filter',{state: {colId: 0, budId: budgetId, catId: 0}})
  }
  return (
    <div className="container mb-5">
      <p className="h3 text-center my-4" style={{ color: Colors.Base_color }}>
        {String.home_headings.shop_on_budget}
      </p>
      <div className="row d-flex align-items-center justify-content-center gap-3">
        {budgetData && budgetData != null ? (
          budgetData.slice(0,3).map((data) => {
            return (
              <Fragment key={data.id}>
              <div
                className="col-lg-2 col-sm-4 col-6 d-flex flex-column align-items-center justify-content-end budget-box p-0"
                style={{ backgroundImage: `url(${Web_url.Domain_url}`+`${data.image})` }}
                onClick={() => BudgetFilter(data.id)}
                role={'button'}
              >
                <div
                  style={{
                    backgroundColor: "#126a38",
                    opacity: 0.7,
                    color: Colors.white_color,
                  }}
                  className="d-flex align-items-center justify-content-between w-100 p-2"
                >
                  <span className="d-flex flex-column">
                    <small>{data.styles} Products</small>
                    <b>Under {data.ending_range}</b>
                  </span>
                  <i class="fa-sharp fa-solid fa-circle-arrow-right"></i>
                </div>
              </div>
              </Fragment>
            );
          })
        ) : (
          <>
          <SkeletonEffect width={"100%"} height={"250px"} />
            {/* <div
              className="col-lg-2 col-sm-4 col-6 d-flex flex-column align-items-center justify-content-end budget-box p-0"
              style={{ backgroundImage: `url(${images.model1})` }}
            >
              <div
                style={{
                  backgroundColor: "#126a38",
                  opacity: 0.7,
                  color: Colors.white_color,
                }}
                className="d-flex align-items-center justify-content-between w-100 p-2"
              >
                <span className="d-flex flex-column">
                  <small>280 Styles</small>
                  <b>Under 100K</b>
                </span>
                <i class="fa-sharp fa-solid fa-circle-arrow-right"></i>
              </div>
            </div>
            <div
              className="col-lg-2 col-sm-4 col-6 d-flex flex-column align-items-center justify-content-end budget-box p-0"
              style={{ backgroundImage: `url(${images.model1})` }}
            >
              <div
                style={{
                  backgroundColor: "#126a38",
                  opacity: 0.7,
                  color: Colors.white_color,
                }}
                className="d-flex align-items-center justify-content-between w-100 p-2"
              >
                <span className="d-flex flex-column">
                  <small>280 Styles</small>
                  <b>Under 100K</b>
                </span>
                <i class="fa-sharp fa-solid fa-circle-arrow-right"></i>
              </div>
            </div>
            <div
              className="col-lg-2 col-sm-4 col-6 d-flex flex-column align-items-center justify-content-end budget-box p-0"
              style={{ backgroundImage: `url(${images.model2})` }}
            >
              <div
                style={{
                  backgroundColor: "#126a38",
                  opacity: 0.7,
                  color: Colors.white_color,
                }}
                className="d-flex align-items-center justify-content-between w-100 p-2"
              >
                <span className="d-flex flex-column">
                  <small>280 Styles</small>
                  <b>Under 100K</b>
                </span>
                <i class="fa-sharp fa-solid fa-circle-arrow-right"></i>
              </div>
            </div> */}
          </>
        )}
      </div>
    </div>
  );
}

export default Budget;
